import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=6418937f&scoped=true"
import script from "./DocumentCategory.vue?vue&type=script&lang=js"
export * from "./DocumentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418937f",
  null
  
)

export default component.exports